import React, { useEffect, useContext, useState, useCallback } from "react";
import { Route, Navigate, Outlet, useNavigate } from "react-router-dom";
import { LOGIN_PATH } from "../../Constants/Path";
import { AppContext } from "../../App";
import AuthService from "../../Pages/Login/AuthService";
import { jwtDecode } from "jwt-decode";

const TOKEN_CHECK_INTERVAL = 60000; // check every 60 seconds

const PrivateRoute = ({ ...rest }) => {
  const { userInfo, setUserInfo } = useContext(AppContext);
  const [userInfoLoaded, setUserInfoLoaded] = useState(false);
  const navigate = useNavigate();

  const handleExpiredToken = useCallback(() => {
    AuthService.logOut();
    setUserInfo(null);
    navigate(LOGIN_PATH, { replace: true });
  }, [navigate, setUserInfo]);

  useEffect(() => {
    if (!AuthService.checkIfTokenExpired()) {
      const info = AuthService.getUserInfo();

      AuthService.setUserToken(info);
      const decoded = jwtDecode(info);
      setUserInfo(decoded);
      setUserInfoLoaded(true);
    } else {
      AuthService.logOut();
      setUserInfo(null);
      setUserInfoLoaded(true);
    }
  }, []);

  // Periodic token expiration check
  useEffect(() => {
    if (!userInfoLoaded || !userInfo) return;

    const interval = setInterval(() => {
      if (AuthService.checkIfTokenExpired()) {
        handleExpiredToken();
      }
    }, TOKEN_CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, [userInfoLoaded, userInfo, handleExpiredToken]);

  if (userInfoLoaded) {
    if (userInfo) {
      return <Outlet />;
    }
    return <Navigate to={LOGIN_PATH} replace />;
  }

  return <span />;
};

export default PrivateRoute;
